import {
  SectionElement,
  defineElement,
  globalOn,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/shop-contact-mobile/shop-contact-mobile.ts
var ShopContactMobile = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isCircle = false;
  }
  connectedCallback() {
    this.contactMobile.addEventListener("click", (e) => {
      var _a;
      if (this.isCircle) {
        e.preventDefault();
        if (this.text) {
          this.text.classList.remove("!w-0", "!opacity-0");
        }
        this.contactMobile.classList.remove("!rounded-full", "!p-4", "!gap-0", "!right-16");
        this.contactMobile.style.boxShadow = "none";
        (_a = this.backdrop) == null ? void 0 : _a.classList.remove("!opacity-0");
        this.isCircle = false;
      }
    });
  }
  handleScroll() {
    this.contactContainer.classList.add("!opacity-100");
    if (!this.isCircle) {
      setTimeout(() => {
        var _a;
        this.isCircle = true;
        if (this.text) {
          this.text.classList.add("!w-0", "!opacity-0");
        }
        this.contactMobile.classList.add("!rounded-full", "!p-4", "!gap-0", "!right-16");
        this.contactMobile.style.boxShadow = "0px 0px 70px 2px rgba(16, 17, 31, 1)";
        (_a = this.backdrop) == null ? void 0 : _a.classList.add("!opacity-0");
      }, 5e3);
    }
  }
};
__decorateClass([
  query("[data-contact-container]")
], ShopContactMobile.prototype, "contactContainer", 2);
__decorateClass([
  query("[data-contact-mobile]")
], ShopContactMobile.prototype, "contactMobile", 2);
__decorateClass([
  query("[data-contact-text]")
], ShopContactMobile.prototype, "text", 2);
__decorateClass([
  query("[data-backdrop]")
], ShopContactMobile.prototype, "backdrop", 2);
__decorateClass([
  globalOn("scroll")
], ShopContactMobile.prototype, "handleScroll", 1);
ShopContactMobile = __decorateClass([
  defineElement("shop-contact-mobile")
], ShopContactMobile);
export {
  ShopContactMobile
};
